import objectToFormData from '../utils/_objectToFormData';
import wishlist from '../utils/_wishlist';

class mPdpInfos extends HTMLDivElement {
    constructor() {
        super();
        this.btnWishlist = this.querySelector('.btn-wishlist');
        this.variationGroupId = this.closest('[is="o-pdp-grid"]').dataset.variationGroupId;
        this.stockState = this.querySelector('[data-stock-state]');
        this.pdpInfosHeader = this.querySelector('[is="m-pdp-infos-header"');
        this.backToSearchBtn = document.querySelectorAll('.btn-backToSearch');

        this.addOrRemoveToWishlist = this.addOrRemoveToWishlist.bind(this);
        this.backToSearchResult = this.backToSearchResult.bind(this);
    }

    connectedCallback() {
        if (this.btnWishlist) {
            this.btnWishlist.addEventListener('click', this.addOrRemoveToWishlist);
            wishlist.activatePdpWishlistButton(this.btnWishlist);
        }

        if (this.backToSearchBtn.length > 0) {
            this.backToSearchBtn.forEach((el) => {
                el.addEventListener('click', this.backToSearchResult);
            });
        }
        if (this.stockState) {
            let eventTag = this.querySelector('.event-tag');
            if (!eventTag) {
                eventTag = document.createElement('div');
                eventTag.classList.add('event-tag');
                const eventText = document.createTextNode(this.stockState.value);
                eventTag.appendChild(eventText);
                this.pdpInfosHeader.insertBefore(eventTag, this.pdpInfosHeader.firstChild);
            } else {
                eventTag.innerText = this.stockState.value;
            }
        }
    }

    addOrRemoveToWishlist() {
        const wishListUrl = GLOBAL_KZ.addToWishlistUrl;
        const wishlistLink = GLOBAL_KZ.wishlistUrl;
        const svgIcon = this.querySelector('svg');
        const currentImgAlt = this.closest('[is="o-pdp-grid"]').querySelector('[is="m-pdp-images"] .swiper-slide img').alt;
        const currentImgUrl = this.closest('[is="o-pdp-grid"]').querySelector('[is="m-pdp-images"] .swiper-slide img').currentSrc;
        const variant = document.querySelector('[is="o-pdp-grid"]').dataset.pid;

        const data = objectToFormData({
            pid: this.variationGroupId,
            optionId: null,
            optionVal: null,
            variantPid: variant || null,
            siteLocation: 'PDP',
        });

        // Ajax call to Wishlist API
        wishlist.addOrRemoveToWishlist(wishListUrl, wishlistLink, data, currentImgUrl, currentImgAlt, svgIcon);
    }

    updateColor(colorAttr) {
        const colorTextElem = this.querySelector('[is="m-pdp-colors-filter"] .info');
        colorTextElem.textContent = colorAttr.displayValue;
    }

    backToSearchResult() {
        let previousUrl = document.referrer;
        if (previousUrl.includes('+')) {
            previousUrl = previousUrl.replace(/\+/g, ' ');
        }

        history.pushState({}, '', previousUrl);
        window.location.reload();
    }
}

customElements.define('m-pdp-infos', mPdpInfos, {
    extends: 'div',
});
